import { render, staticRenderFns } from "./advertpreview.vue?vue&type=template&id=5f1f0d28&"
import script from "./advertpreview.vue?vue&type=script&lang=js&"
export * from "./advertpreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports